import { FeatureFlagTabs } from '@shared/guards/basic-redirect-to-next-tab.guard';

import { ROUTING_PATH } from '../routingPath';

export const BUDGETS_ROUTES_FEATURE_FLAGS: FeatureFlagTabs = {
  [`${ROUTING_PATH.BUDGET.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.BUDGET.LIBRARY}`]:
    'tab_budget_budget_library',
  [`${ROUTING_PATH.BUDGET.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.BUDGET.VENDOR_BUDGET}`]: null,
  [`${ROUTING_PATH.BUDGET.CHANGE_ORDER.INDEX}/${ROUTING_PATH.BUDGET.CHANGE_ORDER.CHANGE_LOG}`]:
    'tab_budget_changelog',
  [`${ROUTING_PATH.BUDGET.CHANGE_ORDER.INDEX}/${ROUTING_PATH.BUDGET.CHANGE_ORDER.COMPARE}`]:
    'tab_compare',
  [`${ROUTING_PATH.BUDGET.PAYMENTS.INDEX}/${ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_MILESTONES}`]:
    'tab_payment_milestones',
  [`${ROUTING_PATH.BUDGET.PAYMENTS.INDEX}/${ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_SCHEDULE}`]:
    'tab_budget_payment_schedule',
  [ROUTING_PATH.BUDGET.CHANGE_ORDER.INDEX]: 'tab_change_order_review',
  [ROUTING_PATH.BUDGET.PURCHASE_ORDERS]: 'tab_purchase_orders',
  [ROUTING_PATH.BUDGET.VENDORS]: 'tab_vendors',
};
